import { Box, Flex, HStack, Image, Text, VStack } from '@chakra-ui/react';
import { useRecoilValue } from 'recoil';

import { companyInfoState, companyNameState } from '../lib/atoms/companyState';
import { company_menu } from '../assets/company';
import usePathNavigate from '../lib/hook/usePathNavigate';
import IconButton from '../components/IconButton';

function Home() {
  const { pathNavigate } = usePathNavigate();

  const companyName = useRecoilValue(companyNameState);
  const companyInfo = useRecoilValue(companyInfoState);
  // console.log(companyName);
  // console.log(companyInfo[companyName]);

  const onMenuHandler = async (index: number) => {
    window.open(companyInfo[companyName].link[index], '_blank');
  };
  // console.log(companyName);
  return (
    <Flex flexDirection="column" alignItems={'center'} position={'relative'}>
      <Box mt="29px" w="100%" bg={'white'} aspectRatio={1}>
        <Image
          src={companyInfo[companyName].image}
          w="full"
          h="full"
          fit={'contain'}
        />
      </Box>
      <HStack
        mt={'35px'}
        w={'100%'}
        px={'34px'}
        justifyContent={'space-between'}>
        {company_menu.map((menu, index) => (
          <VStack
            key={index}
            spacing={'6px'}
            onClick={() => onMenuHandler(index)}>
            {/* <Image src={`/assets/images/icn_oemordermenu${index + 1}.svg`} /> */}
            <Image src={companyInfo[companyName].icn[index]} boxSize={'38px'} />
            <Text fontSize={'13px'} fontWeight="normal">
              {companyInfo[companyName].name[index]}
            </Text>
          </VStack>
        ))}
      </HStack>
      <HStack w={'full'} px={'21px'} mt={'53px'} mb={'15px'}>
        <Box w={'full'}>
          <IconButton
            iconPath="/assets/images/icn_oemordermenu5.svg"
            text={companyInfo[companyName]?.ordertitle}
            onClickHandler={() => {
              pathNavigate('/order');
            }}
          />
        </Box>
        {/* <Box w={'full'}>
          <IconButton
            iconPath="/assets/images/icn_webordermenu5.svg"
            text="진행조회"
            onClickHandler={() => {
              pathNavigate('/progresscheck');
            }}
          />
        </Box> */}
      </HStack>
      {/* <Box w={'full'} px={'21px'} mt={'20px'}>
        <IconButton
          iconPath="/assets/images/icn_webordermenu5.svg"
          text="진행조회"
          onClickHandler={() => {
            pathNavigate('/progresscheck');
          }}
        />
      </Box> */}
    </Flex>
  );
}

export default Home;
